module.exports={render:function (){var _vm=this;
  return _vm._h('header', {
    staticClass: "z-depth-1"
  }, [_vm._h('v-nav', {
    attrs: {
      "nav-class": "z-depth-0 grey lighten-5"
    }
  }, [_vm._h('div', {
    staticClass: "nav-wrapper container"
  }, [_vm._h('router-link', {
    staticClass: "brand-logo left",
    attrs: {
      "to": "/"
    }
  }, ["Hoge", _vm._m(0)]), " ", _vm._h('ul', {
    staticClass: "right hide-on-med-and-down nav-link-list"
  }, [_vm._h('li', [_vm._h('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._s(_vm.$t('menu.top'))])]), " ", _vm._h('li', [_vm._h('router-link', {
    attrs: {
      "to": "/overview"
    }
  }, [_vm._s(_vm.$t('menu.overview'))])]), " ", _vm._h('li', [_vm._h('router-link', {
    attrs: {
      "to": "/members"
    }
  }, [_vm._s(_vm.$t('menu.members'))])]), " ", _vm._h('li', [_vm._h('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._s(_vm.$t('menu.contact'))])]), " "])]), " ", _vm._h('v-container', [_vm._h('div', {
    staticClass: "nav-wrapper center-align hide-on-large-only sub-menu"
  }, [_vm._h('ul', {
    staticClass: "nav-link-list"
  }, [_vm._h('li', {
    staticClass: "sub-menu-item"
  }, [_vm._h('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._s(_vm.$t('menu.top'))])]), " ", _vm._h('li', {
    staticClass: "sub-menu-item"
  }, [_vm._h('router-link', {
    attrs: {
      "to": "/overview"
    }
  }, [_vm._s(_vm.$t('menu.overview'))])]), " ", _vm._h('li', {
    staticClass: "sub-menu-item"
  }, [_vm._h('router-link', {
    attrs: {
      "to": "/members"
    }
  }, [_vm._s(_vm.$t('menu.members'))])]), " ", _vm._h('li', {
    staticClass: "sub-menu-item"
  }, [_vm._h('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._s(_vm.$t('menu.contact'))])])]), " "])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('span', {
    staticClass: "orange-text darken-4"
  }, [".class"])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a8fd89f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 56
// module chunks = 2